import type { EarnedBadgeType } from '@/apiTypes/EarnedBadgeTypes';
import { cn } from '@/lib/utils';
import { EARNED_BADGE_TYPES } from './earnedBadgeRegistry';

export interface EarnedBadgeArtProps {
    type: EarnedBadgeType;
    className?: string;
}

export const EarnedBadgeArt = ({ type, className }: EarnedBadgeArtProps) => (
    <img src={EARNED_BADGE_TYPES[type].art} alt="" aria-hidden="true" className={cn('aspect-[5/6] shrink-0', className)} />
);
